import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { publicRoutes, appRoutes, adminRoutes, PublicLayout, AppLayout, AdminLayout } from '@config/routes';
import { RequireAuth } from '@shared/guards/RequireAuth';
import { RequireRole } from '@shared/guards/RequireRole';
import { ROLES } from '@config/constants';
import { HomePage, PricingPage } from '@features/marketing';
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage, LoginSuperAdminPage } from '@features/auth';
import { SuperAdminDashboardPage, SuperAdminListPage } from '@features/super-admins';
import { CustomerListPage } from '@features/customers';
import { PackageListPage } from '@features/packages';
import { OrderListPage } from '@features/orders';

// Placeholder pages - will be replaced with actual feature pages
const AppDashboardPage = () => (
  <div className="card">
    <h1>App Dashboard</h1>
    <p>Welcome to HRM SaaS App</p>
  </div>
);
const AdminPlaceholderPage = ({ title }: { title: string }) => (
  <div className="card">
    <h2 className="card-title mb-2">{title}</h2>
    <p className="card-subtitle">Tính năng sẽ được cập nhật trong giai đoạn tiếp theo.</p>
  </div>
);

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route path={publicRoutes.home} element={<HomePage />} />
          <Route path={publicRoutes.login} element={<LoginPage />} />
          <Route path={adminRoutes.login} element={<LoginSuperAdminPage />} />
          <Route path={publicRoutes.register} element={<RegisterPage />} />
          <Route path={publicRoutes.forgotPassword} element={<ForgotPasswordPage />} />
          <Route path={publicRoutes.resetPassword} element={<ResetPasswordPage />} />
          <Route path={publicRoutes.pricing} element={<PricingPage />} />
        </Route>

        {/* App Routes (Admin Company, Custom Role, Member) */}
        <Route
          element={
            <RequireAuth>
              <RequireRole allowedRoles={[ROLES.ADMIN_COMPANY, ROLES.CUSTOM_ROLE, ROLES.MEMBER]}>
                <AppLayout />
              </RequireRole>
            </RequireAuth>
          }
        >
          <Route path={appRoutes.dashboard} element={<AppDashboardPage />} />
          {/* Add more app routes here */}
        </Route>

        {/* Admin Routes (Super Admin) */}
        <Route
          element={
            <RequireAuth>
              <RequireRole allowedRoles={[ROLES.SUPER_ADMIN]}>
                <AdminLayout />
              </RequireRole>
            </RequireAuth>
          }
        >
          <Route path={adminRoutes.dashboard} element={<SuperAdminDashboardPage />} />
          <Route path={adminRoutes.superAdmins} element={<SuperAdminListPage />} />
          <Route path={adminRoutes.companies} element={<AdminPlaceholderPage title="Quản lý công ty" />} />
          <Route path={adminRoutes.orders} element={<OrderListPage />} />
          <Route path={adminRoutes.package} element={<PackageListPage />} />
          <Route path={adminRoutes.subscriptions} element={<AdminPlaceholderPage title="Quản lý đăng ký" />} />
          <Route path={adminRoutes.customers} element={<CustomerListPage />} />
          <Route path={adminRoutes.reports} element={<AdminPlaceholderPage title="Báo cáo tổng quan" />} />
        </Route>

        {/* Default redirect */}
        <Route path="*" element={<Navigate to={publicRoutes.home} replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;

